import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import * as StringUtils from 'web-app/util/string';

export const registerAction = (childId, actionType, payload, occuredOn) => {
    return RESTClient.postAuthenticatedObservable('v2/actions', {
        recipient: StringUtils.fromChildIdToRecipient(childId),
        actionType,
        occuredOn,
        payload,
    });
};
